var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.649658L13.87 0.879654L20.08 7.08966L20.33 7.51965V25.0897C20.26 26.3197 19.4 27.2297 18.18 27.3596H2.26996C0.999959 27.2796 0.08 26.3697 0 25.0897V2.80966C0.09 1.98966 0.52999 1.31965 1.23999 0.909653L2.03998 0.639648H13.52L13.5 0.649658ZM12.5 2.21965H2.14996C1.99996 2.21965 1.59001 2.59966 1.57001 2.78966V25.2197C1.67001 25.5396 1.95999 25.7697 2.29999 25.7897L18.19 25.7597C18.38 25.7497 18.76 25.3297 18.76 25.1797V8.45966H14.56C13.68 8.45966 12.5 7.27966 12.5 6.39966V2.19966V2.21965ZM17.62 6.90965L14.07 3.35965V6.30966C14.07 6.46966 14.52 6.90965 14.67 6.90965H17.62Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29018 11.7197H14.9302C15.8702 11.8697 15.8702 13.1097 14.9302 13.2697H5.3802C4.4902 13.1197 4.43018 11.9697 5.29018 11.7197Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29018 14.8496H14.9302C15.8702 14.9996 15.8702 16.2396 14.9302 16.3996H5.3802C4.4902 16.2496 4.43018 15.0996 5.29018 14.8496Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29018 17.9795H14.9302C15.8702 18.1295 15.8702 19.3695 14.9302 19.5295H5.3802C4.4902 19.3795 4.43018 18.2295 5.29018 17.9795Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28981 21.1094H11.8498C12.7498 21.3194 12.7098 22.5094 11.7998 22.6594H5.32979C4.47979 22.4494 4.44981 21.3594 5.28981 21.1094Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.e84ca417f42f9fe2638b0d3ad790d135.svg";
export { ForwardRef as ReactComponent };